import { render } from "@/components/pages/individualWorkSupport/requirement052/Requirement052.html?vue&type=template&id=39365e7c&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement052/Requirement052.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement052/Requirement052.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement052/Requirement052.scss?vue&type=style&index=0&id=39365e7c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39365e7c"]])

export default __exports__